import React from "react";
import styled from "styled-components";
import { CourseCarouselItem } from "../../../types";
import CarouselItem from "./item";
import { BreakpointsQuery } from "../../../constants/device";

interface Props {
  courses: CourseCarouselItem[];
}

const CarouselWrapper = styled.div`
  display: flex;
  transition: display 2s;
  flex-direction: row;
  -ms-overflow-style: none; /* hide scrollbar in IE and Edge */
  scrollbar-width: none;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.4rem;
  width: 60rem;
  min-height: fit-content;
  @media ${BreakpointsQuery.tablet} {
    width: 52rem;
  }
`;

/*
  La card mostra nome corso, modalita' di erogazione e citta'. Raggruppare sul solo nome
  faceva sparire dalla lista le edizioni che differiscono per modalita': un corso con
  edizioni sia in presenza sia in videoconferenza compariva una volta sola, con la
  modalita' di un'edizione qualsiasi, e l'altra non era raggiungibile se non entrando
  nella scheda del corso.

  Si raggruppa quindi per nome + modalita', e si ordina per data crescente in modo che
  l'edizione mostrata sia sempre la piu' vicina: il backend restituisce un Set non
  ordinato, quindi prima l'edizione rappresentativa cambiava a ogni caricamento.
*/
const chiaveCard = (course: CourseCarouselItem) =>
  `${course.courseName.trim().toUpperCase()}|${course.mode}`;

const CourseList = ({ courses }: Props) => {
  const viste = new Set<string>();
  const courseList: CourseCarouselItem[] = [...courses]
    .sort(
      (a, b) =>
        new Date(a.date.toString()).getTime() -
        new Date(b.date.toString()).getTime()
    )
    .filter((course) => {
      const chiave = chiaveCard(course);
      if (viste.has(chiave)) return false;
      viste.add(chiave);
      return true;
    });
  return (
    <CarouselWrapper>
      <ListWrapper>
        {courseList.map((singleCourse, index) => {
          return <CarouselItem item={singleCourse} key={index} />;
        })}
      </ListWrapper>
    </CarouselWrapper>
  );
};

export default CourseList;
